// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1iqqX","resendInfoText":"OnGoingPaymentBox_resendInfoText__1aY_6"};